class Geolocation
{
    latitude: number = 0;
    longitude: number = 0;
    altitude: number = 0;
    horizAccuracy: number = -1;
    vertAccuracy: number = -1;

    constructor(str: string) {
        let items = str.split(' ');
        if (items.length < 5) {
            return;
        }
        this.latitude     = +items[0];
        this.longitude    = +items[1];
        this.altitude      = +items[2];
        this.horizAccuracy = +items[3];
        this.vertAccuracy  = +items[4];
    }
}
export default Geolocation;